import React from 'react';
import PropTypes from 'prop-types';

 const Slider = ({children}) => {
  return (
      <div className={`slider-outer`}>
        <div className={`slider-inner`}>
          {children}
        </div>
      </div>
  )
};

Slider.propTypes = {
  children: PropTypes.oneOfType([
    PropTypes.arrayOf(PropTypes.node),
    PropTypes.node
  ]).isRequired
};


export default Slider